export default {
    path: '/home',
    name: 'index',
    meta: {
        title: '首页',
    },
    children: [
        {
            path: 'index',
            component: () => import("@/views/index/index.vue"),
            meta: {
                title: "首页",
               
                
                permissionCode: "pcIndex",
                state: 'home'
            },
        },
        {
            path: 'agencyCenter',
            component: () => import("@/views/generalDepartment/agencyCenter/list.vue"),
            meta: {
                permissionCode: "pcIndex",
                title: '待办流程',
               
                
            },
        },
        {
            path: 'dailyList',
            component: () => import("@/views/index/list.vue"),
            meta: {
                permissionCode: "pcIndex",
                title: '日常事务管理',
               
                
            },
        },
        {
            path: 'newsList',
            component: () => import("@/views/newsList/list.vue"),
            meta: {
                permissionCode: "pcNewsList",
                title: '消息中心',
               
                
            },
        },
    ]
}